import type { UIMatch } from '@remix-run/react'

export type HeaderHandle = {
  headerSimple?: boolean
}

export type HeaderMatch = UIMatch<unknown, HeaderHandle | unknown>

export function computeHeaderSimple(matches: HeaderMatch[]): boolean {
  for (const m of matches) {
    const handle = m.handle as HeaderHandle | undefined
    if (handle?.headerSimple === true) return true
  }
  return false
}
